export default class LoginPage {
  constructor() {
    const loginPage = document.getElementsByClassName("login-signup-page");

    if (loginPage) {
      this.emailHasValue();
      this.passwordHasValue();
      this.toggleReveal();
      this.submitForm();
    }
  }

  emailHasValue = () => {
    $('input[type="email"]').change(function () {
      let hasValue = $(this).val() ? "has_value" : "no_value";

      $(this).parent().attr("class", `form-group col-md-12 field--email ${hasValue}`);
    });
  };

  passwordHasValue = () => {
    $("#user_password").change(function () {
      let hasValue = $(this).val() ? "has_value" : "no_value";

      $(this)
        .parent()
        .parent()
        .attr("class", `form-group col-md-12 field--password ${hasValue}`);
    });
  };

  toggleReveal = () => {
    $(".reveal-password").on("click", (event) => {
      const $passwordContainer = $(event.currentTarget).parent();
      $passwordContainer
        .toggleClass("visible")
        .find("input")
        .attr("type", $passwordContainer.hasClass("visible") ? "text" : "password");
      $(event.currentTarget).children().first().toggleClass("fa-eye fa-eye-slash");
      $(event.currentTarget).attr(
        "aria-label",
        $passwordContainer.hasClass("visible") ? "Hide password" : "Show password",
      );
    });
  };

  submitForm = () => {
    $("form").submit((event) => {
      $(this).find(".field--password input").attr("type", "password");
      return true;
    });
  };
}
